export const COMPANY_ALIAS = process.env.REACT_APP_COMPANY_ALIAS || 'DIBS AI';
